import request from '@/utils/request'

/**
 * 部门列表
 */
export const getDepartmentList = (data) => {
    return request({
        url: '/department/lists',
        params: data
    })
}

/**
 * 部门tree
 */
export const getDepartmentTree = (data) => {
    return request({
        url: '/department/tree',
        params: data
    })
}

/**
 * 部门选项列表
 */
export const getDepartmentOptions = () => {
    return request({
        url: '/department/option/lists'
    })
}

/**
 * 部门选项tree列表
 */
export const getDepartmentOptionsTree = () => {
    return request({
        url: '/department/option/tree'
    })
}

/**
 * 新增部门
 */
export const addDepartment = (data) => {
    return request({
        url: '/department/manage',
        method: 'POST',
        data
    })
}

/**
 * 部门-详情
 */
export const getDepartmentDetail = (id) => {
    return request({
        url: `/department/${id}`
    })
}

/**
 * 部门-编辑
 */
export const putDepartment = (data) => {
    return request({
        url: '/department/manage',
        method: 'PUT',
        data
    })
}

/**
 * 部门-删除
 */
export const delDepartment = (id) => {
    return request({
        url: `/department/${id}`,
        method: 'DELETE'
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/department/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/department/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/department/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}

/**
 * 批量处理
 * batch_update_order 更新排序
 * batch_enable 批量启用
 * batch_disable 批量禁用
 * batch_display 批量显示
 * batch_hidden 批量隐藏
 */
export const batchPatch = (method, data) => {
    return request({
        url: '/department/manage',
        method: 'PATCH',
        data: {
            method,
            data
        }
    })
}
